import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {OrcamentoRastreamentoFilter} from "@models/orcamento/OrcamentoRastreamentoFilter.ts";
import {useEffect, useState} from "react";
import {ISolicitacaoOrcamentoRastreio} from "@models/orcamento/ISolicitacaoOrcamentoRastreio.ts";
import {Grid, IconButton, Table, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {_OrcamentosEndpoints} from "@localization/siteMap/endpoints/_OrcamentosEndpoints.ts";
import {CodigoRastreioRow} from "@components/orcamento/rastreio/CodigoRastreioRow.tsx";
import {MoreHoriz} from "@mui/icons-material";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CodigoRastreioGrid} from "@components/orcamento/rastreio/CodigoRastreioGrid.tsx";
import {CreateCodigoRastreioComponent} from "@components/orcamento/rastreio/CreateCodigoRastreioComponent.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";

interface RastreamentoPageProps extends DefaultPageProps {
    filtros?: OrcamentoRastreamentoFilter,
    orcamento?: ISolicitacaoOrcamento
}

export function RastreamentosPage(props: RastreamentoPageProps) {
    const {filtros, ...restProps} = props;
    const {addPopUp, closePopUp} = useAlert()
    const {Get} = useApi()

    const [rastreamentos, setRastreamentos] = useState<ISolicitacaoOrcamentoRastreio[]>([]);
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});

    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination({...pagination, page: 1, pageSize: 10})
            return
        }
        setPagination(prev => ({...prev, loading: true}))
        Get(_OrcamentosEndpoints.GetRastreamentos({...filtros}, pagination)).then(x => {
            if (x.hasData) {
                setPagination(prev => ({...prev, ...x.pagination}))
                setRastreamentos(x.items)
            }
        }).finally(() => {
            setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
        })
    }, [pagination.page, pagination.ignoreCache == true]);


    return <DefaultContainer pageProps={{pagination, setPagination}} {...restProps}
                             titulo={'Rastreamento'}
                             UpperComponent={
                                 <Grid container justifyContent={'space-between'}>
                                     <Grid/>
                                     {props.orcamento != null && <Grid>
                                         <PermissionableButton disabled={['Finalizado',
                                             'Rejeitado',
                                             'Cancelado'].includes(props.orcamento.status) || props.orcamento.dataCompraEfetuada == null}
                                                               onClick={() => {
                                                                   if (props.orcamento != null)
                                                                       addPopUp({
                                                                               title: 'Incluir codigo de rastreamento',
                                                                               content: <CreateCodigoRastreioComponent
                                                                                   idOrcamento={props.orcamento.id}
                                                                                   onCreate={() => {
                                                                                       closePopUp()
                                                                                       setPagination(prev => ({
                                                                                           ...prev,
                                                                                           ignoreCache: true
                                                                                       }))
                                                                                   }
                                                                                   }/>,
                                                                               size: 'lg'
                                                                           }
                                                                       )
                                                               }}>Incluir codigo de rastreamento</PermissionableButton>
                                     </Grid>}
                                 </Grid>}
    >

        <TableContainer>
            <Table stickyHeader size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Código</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Data de inclusao</TableCell>
                        <TableCell>Previsão de entrega</TableCell>
                        <TableCell>Data de entrega</TableCell>
                        <TableCell>Mais</TableCell>
                    </TableRow>
                </TableHead>
                {rastreamentos.map((x) => <CodigoRastreioRow key={x.id} events={{
                    onUpdate: () => {
                        setPagination(prev => ({...prev, ignoreCache: true}))
                    }
                }} EndComponent={(v) => <IconButton onClick={() => {
                    addPopUp({
                        title: 'Mais opção do rastreio',
                        content: <CodigoRastreioGrid value={v} events={{
                            onUpdate: () => {
                                setPagination(prev => ({...prev, ignoreCache: true}))
                                closePopUp()
                            }
                        }}/>,
                        size: 'lg'
                    })

                }}>
                    <MoreHoriz/>
                </IconButton>} value={x}/>)}
            </Table>
        </TableContainer>
    </DefaultContainer>;
}